/**
 * TonConnect manifest URL.
 *
 * The TonConnect UI library requires a publicly reachable manifest JSON
 * describing the dApp. In dev we serve it from `public/` so the URL is
 * `http://localhost:5173/tonconnect-manifest.json`. In production it
 * should be hosted on the same origin as the Mini App.
 *
 * We compute the URL from `window.location.origin` at runtime so the same
 * code works across dev, staging, and prod without a build-time substitution.
 */

export const TONCONNECT_MANIFEST_PATH = '/tonconnect-manifest.json';

export function getTonconnectManifestUrl(): string {
  // SSR safety (unused today but trivial insurance).
  if (typeof window === 'undefined') {
    return `https://0xcent.app${TONCONNECT_MANIFEST_PATH}`;
  }
  return `${window.location.origin}${TONCONNECT_MANIFEST_PATH}`;
}
